import React, { useState } from "react";
import { ROLE_ADMIN, ROLE_USER } from "./constants";

const CreateUserForm = ({newUser, setNewUser, handleAddUser}) => {
  const [emailError, setEmailError] = useState(null);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (!validateEmail(newUser.email)) {
      setEmailError("Invalid email address.");
      return;
    }

    setEmailError(null);
    handleAddUser(event);
  };

  return (
    <form onSubmit={onSubmit}>
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
        <input
          type="text"
          placeholder="Name"
          value={newUser.name}
          onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '150px' }}
        />
        <input
          type="email"
          autoComplete="off"
          placeholder="Email"
          value={newUser.email}
          onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '200px' }}
        />
        <input
          type="password"
          placeholder="Password"
          autoComplete="off"
          value={newUser.password}
          onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '200px' }}
        />
        <select
          value={newUser.role}
          onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc', width: '120px' }}
        >
          <option value="">Select role</option>
          <option value={ROLE_USER}>User</option>
          <option value={ROLE_ADMIN}>Admin</option>
        </select>
        <button type="submit" style={{ cursor: "pointer", padding: '8px 16px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px' }}>
          Add User
        </button>
      </div>
      {emailError && <p style={{ color: 'red', textAlign: 'center', paddingBottom: '10px' }}>{emailError}</p>}
    </form>
  )
}

export default CreateUserForm;